module.exports = __webpack_public_path__ + "static/media/tongyong.21f1984653c9413083c1d937d993295b.svg";